import React, { Component } from 'react';
import moment from 'moment';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as EventsActions } from 'store/ducks/events';
// import { Creators as AuthActions } from 'store/ducks/auth';

import { Validate, Access } from 'common';
import { Page, Breadcrumbs } from 'components';
import { Form } from 'pages/Events/components';

class Create extends Component {
  state = {
    data: {
      name: '',
      price: 0,
      speaker_id: '',
      alias_speaker: '',
      type: null,
      description: '',
      date: null,
      date_end: null,
      date_sale_start: null,
      date_sale_end: null,
      local: Access.lockedLocal() ? Access.lockedLocal(true) : { value: '', label: 'Não Será na Loja' },
      alternative_location: '',
      vacancy: '',
      price_points: 0,
      experience_plan_ids: [],
      difficulty: null,
      active: false,
    },
    errors: {},
    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Eventos', to: '/events' },
      { name: 'Lista de Eventos', to: '/events/list' },
      { name: 'Adicionar Novo', to: '' },
    ],
  };

  handleChange = data => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      name: {
        required: true,
      },

      description: {
        required: true,
      },

      vacancy: {
        required: true,
      },

      date: {
        required: true,
      },

      date_end: {
        required: true,
      },

      date_sale_start: {
        required: true,
      },

      date_sale_end: {
        required: true,
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSave = () => {
    if (!this.handleValidate()) return null;

    const { data } = this.state;
    const { createEventRequest, user } = this.props;

    createEventRequest({
      event: {
        name: data.name,
        speaker_id: user.data.id,
        price: data.price,
        type_id: data.type.value,
        description: data.description,
        date: moment(data.date).format('YYYY-MM-DD HH:mm'),
        date_end: moment(data.date_end).format('YYYY-MM-DD HH:mm'),
        date_sale_start: moment(data.date_sale_start).format('YYYY-MM-DD HH:mm'),
        date_sale_end: moment(data.date_sale_end).format('YYYY-MM-DD HH:mm'),
        local_id: data.local.value,
        alternative_location: data.alternative_location,
        vacancy: data.vacancy,
        alias_speaker: data.alias_speaker,
        experience_plan_ids: data.experience_plan_ids.map(plan => plan.value),
        price_points: data.price_points,
        active: data.active,
        difficulty_id: data.difficulty !== null ? data.difficulty.value : null,
      },
    });
  };

  render() {
    const { data, errors, breadcrumbs } = this.state;
    const { create } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          errors={errors}
          saving={create.loading}
          onChange={this.handleChange}
          onSave={this.handleSave}
        />
      </Page>
    );
  }
}

const mapstate = state => ({
  create: state.events.create,
  user: state.auth.user,
});

const mapActions = dispatch => bindActionCreators(EventsActions, dispatch);

export default connect(
  mapstate,
  mapActions,
)(Create);
